import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Container } from "reactstrap"

//Import sections
import SeasonPassList from "./SeasonPassList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const SeasonPassView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Season Passes | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Season Passes"
            breadcrumbItem="Manage Season Passes"
          />
          <SeasonPassList />
        </Container>
      </div>
    </React.Fragment>
  )
}

SeasonPassView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(SeasonPassView)
